import { IClinique } from 'components/core/types'

export default (clinique: IClinique, lineBreak = false) => {
  const {
    marker,
    address,
    post_code,
    city,
  } = clinique.acf
  const streetAddress = address ?? marker.name
  const cityAddress = [post_code ?? marker.post_code, city ?? marker.city].join(' ')
  return [streetAddress, cityAddress].join(lineBreak ? '<br>' : ', ')
}
